export default {
  path: 'inbox',
  name: 'inbox',
  meta: {
    title: 'Inbox'
  },
  component: () => import('./InboxPage.vue')
}
